import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Idea from 'components/ideas';
import Entry from 'components/entry/Entry';
import UserUnsubscribe from 'components/users/Unsubscribe';
import PublicChallenges from 'components/challenges/PublicChallenges';
import Challenge from 'components/challenges/Challenge';
import { LoggedOutInvitation } from 'components/users/Invitations';

const NonUserSwitch = ({
  user, showLogin, gettingUserError,
}) => {
  if (!user && (showLogin || !gettingUserError)) {
    return (
      <Switch>
        <Route path="/unsubscribe" component={UserUnsubscribe} />
        <Route path="/invitations" component={LoggedOutInvitation} />
        <Route path="/ideas/:id" component={Idea} />
        <Route path="/challenges/public" component={PublicChallenges} />
        <Route path="/challenges/:id" component={Challenge} />
        <Route component={Entry} />
      </Switch>
    );
  }
  return null;
};

const mapStateToProps = ({ user, auth }) => ({ user, showLogin: auth.showLogin, gettingUserError: auth.errorMessage });

export default connect(mapStateToProps)(NonUserSwitch);
